module.exports = __webpack_public_path__ + "static/media/edit.75b51b7b.svg";